var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoSquareFillpaypg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.25C0 1.65326 0.237053 1.08097 0.65901 0.65901C1.08097 0.237053 1.65326 0 2.25 0L15.75 0C16.3467 0 16.919 0.237053 17.341 0.65901C17.7629 1.08097 18 1.65326 18 2.25V15.75C18 16.3467 17.7629 16.919 17.341 17.341C16.919 17.7629 16.3467 18 15.75 18H2.25C1.65326 18 1.08097 17.7629 0.65901 17.341C0.237053 16.919 0 16.3467 0 15.75V2.25ZM10.0463 7.4115L7.47 7.73438L7.37775 8.16187L7.884 8.25525C8.21475 8.334 8.28 8.45325 8.208 8.78288L7.37775 12.6844C7.1595 13.6935 7.49588 14.1683 8.28675 14.1683C8.89988 14.1683 9.612 13.8848 9.93488 13.4955L10.0339 13.0275C9.80888 13.2255 9.48037 13.3043 9.26213 13.3043C8.95275 13.3043 8.84025 13.0871 8.92013 12.7046L10.0463 7.4115ZM9 6.1875C9.29837 6.1875 9.58452 6.06897 9.7955 5.858C10.0065 5.64702 10.125 5.36087 10.125 5.0625C10.125 4.76413 10.0065 4.47798 9.7955 4.267C9.58452 4.05603 9.29837 3.9375 9 3.9375C8.70163 3.9375 8.41548 4.05603 8.2045 4.267C7.99353 4.47798 7.875 4.76413 7.875 5.0625C7.875 5.36087 7.99353 5.64702 8.2045 5.858C8.41548 6.06897 8.70163 6.1875 9 6.1875Z",
    fill: "#616161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSquareFillpaypg);
export default __webpack_public_path__ + "static/media/InfoSquareFillpaypg.b4fd5c8e62b6acadf3db3465cde32eb4.svg";
export { ForwardRef as ReactComponent };